import React, { useContext, type JSX } from 'react';
import { KodplanContext } from '../../../../../../../Components/KodplanManager/Context/KodplanContext';
import { ActiveDatabaseContext } from '../../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { Mutation } from '@apollo/client/react/components';
import { MutationFunction as MutationFn, FetchResult } from '@apollo/client';
import {
  EkonomiskAnalysSaveDBSettingMutationVariables,
  EkonomiskAnalysSaveDBSettingMutation as SaveDBSettingMutationResult,
} from './_QueryTypes/EkonomiskAnalysSaveDBSettingMutation';
import mutation from './EkonomiskAnalysSaveDBSettingMutation.gql';
import { paddedEkonomiskAnalysRutinId } from '../../Components/SideMenu/EkonomiskAnalysSelect/Components/FavoriteAnalysDialog/Queries/ChangeStartAnalysMutation/ChangeStartAnalysMutation';
import EkonomiskAnalysInitQuery from '../EkonomiskAnalysInitQuery/AnalysInitQuery.gql';

interface IProps {
  children: (
    saveAnalysGroupingMode: EkonomiskAnalysSaveDBSettingType
  ) => JSX.Element;
}

export type EkonomiskAnalysSaveDBSettingType = (
  name: string,
  newValue: ISaveDBSettingValue
) => Promise<void | FetchResult<SaveDBSettingMutationResult>>;

interface ISaveDBSettingValue {
  id: string;
  value: string;
}

const createSaveFunction =
  (
    saveDBSettingMutation: MutationFn<
      SaveDBSettingMutationResult,
      EkonomiskAnalysSaveDBSettingMutationVariables
    >,
    activeDatabase: string | null,
    codeplanID: string | undefined
  ) =>
  (
    name: string,
    newValue: ISaveDBSettingValue
  ): Promise<void | FetchResult<SaveDBSettingMutationResult>> => {
    return saveDBSettingMutation({
      variables: {
        section: [
          {
            name: `Forms/${paddedEkonomiskAnalysRutinId}`,
            values: [
              {
                name: name,
                asString: newValue.value,
              },
            ],
          },
        ],
        dbname: activeDatabase ?? '',
      },
      refetchQueries: () => {
        if (codeplanID !== undefined) {
          return [
            {
              query: EkonomiskAnalysInitQuery,
              variables: {
                codeSystemId: codeplanID,
                dbName: activeDatabase ?? '',
                onlyFavorites: false,
                section: [`Forms/${paddedEkonomiskAnalysRutinId}`],
                subsystemCode: 'EK',
              },
            },
          ];
        } else {
          return [];
        }
      },
    });
  };

const EkonomiskAnalysSaveDBSettingMutation: React.FC<IProps> = props => {
  const activeDatabaseContext = useContext(ActiveDatabaseContext);
  const kodplanContext = useContext(KodplanContext);

  return (
    <Mutation<
      SaveDBSettingMutationResult,
      EkonomiskAnalysSaveDBSettingMutationVariables
    >
      mutation={mutation}
    >
      {saveDBSettingMutationFn =>
        props.children(
          createSaveFunction(
            saveDBSettingMutationFn,
            activeDatabaseContext.activeDatabase,
            kodplanContext.activeKodplan?.id
          )
        )
      }
    </Mutation>
  );
};

export default EkonomiskAnalysSaveDBSettingMutation;
